<template>
  <div class="uk-container">
    <div
      class="uk-card uk-card-default uk-card-body"
      style="z-index: 980;"
      uk-sticky="bottom: #offset"
    >
      <button
        :disabled="!changed"
        class="uk-button uk-button-primary"
        @click="updateColors"
      >
        Save Changes
      </button>
    </div>
    <h2>Add Color</h2>
    <table class="uk-table uk-table-striped">
      <thead>
        <tr>
          <th>Color Name</th>
          <th>Category</th>
          <th>Hex</th>
          <th>Color Set</th>
          <th>Delete Color</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <input
              v-model="newColor.colorName"
              class="uk-input"
              type="text"
              placeholder="Color Name"
            />
          </td>
          <td>
            <input
              v-model="newColor.category"
              class="uk-input"
              type="text"
              placeholder="Category"
            />
          </td>
          <td>
            <input
              v-model="newColor.hex"
              class="uk-input"
              type="text"
              placeholder="#Hex"
            />
          </td>
          <td>
            <input
              v-model="newColor.colorSet"
              class="uk-input"
              type="text"
              placeholder="Color Set"
            />
          </td>
          <td>
            <button class="uk-button uk-button-primary" @click="addColor()">
              Add
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <h2>Edit Colors</h2>
    <table class="uk-table uk-table-striped">
      <thead>
        <tr>
          <th>Color Name</th>
          <th>Category</th>
          <th>Hex</th>
          <th>Color Set</th>
          <th>Delete Color</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(color, index) in colors">
          <td>
            <input
              v-model="color.colorName"
              class="uk-input"
              type="text"
              placeholder="Input"
            />
          </td>
          <td>
            <input
              v-model="color.category"
              class="uk-input"
              type="text"
              placeholder="Input"
            />
          </td>
          <td>
            <input
              v-model="color.hex"
              class="uk-input"
              type="text"
              placeholder="Input"
            />
          </td>
          <td>
            <input
              v-model="color.colorSet"
              class="uk-input"
              type="text"
              placeholder="Input"
            />
          </td>
          <td>
            <button
              class="uk-button uk-button-danger"
              @click="deleteColor(index)"
            >
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
//import ColorsService from "@/services/ColorsService";
import firebase from "firebase";

export default {
  name: "AdminColors",

  data() {
    return {
      colors: [],
      newColor: {
        colorName: "",
        category: "",
        hex: "",
        colorSet: ""
      },
      changed: false
    };
  },

  computed: {},

  watch: {
    colors: {
      handler() {
        this.changed = true;
      },
      deep: true
    }
  },
  mounted: function() {
    var self = this;
    const colorsRef = firebase
      .firestore()
      .collection("colors")
      .doc("0");
    colorsRef
      .get()
      .then(function(doc) {
        if (doc.exists) {
          let c = doc.data();
          for (const i of c["knotty-colors"]) {
            i.show = true;
          }
          const knottyColors = c["knotty-colors"];
          self.colors = knottyColors;
          setTimeout(() => {
            self.changed = false;
          }, 500);
        } else {
          // doc.data() will be undefined in this case
          console.warn("No such document!");
        }
      })
      .catch(function(error) {
        console.error("Error getting document:", error);
      });
  },

  methods: {
    deleteColor(index) {
      this.colors.splice(index, 1);
    },
    addColor() {
      this.colors.push(this.newColor);
      this.newColor = {
        colorName: "",
        category: "",
        hex: "",
        colorSet: ""
      };
    },
    updateColors() {
      let self = this;
      const colors = { "knotty-colors": this.colors };
      var colorsRef = firebase
        .firestore()
        .collection("colors")
        .doc("0");
      colorsRef
        .update(colors)
        .then(function() {
          self.changed = false;
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminColors.vue